import React, { Fragment, useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import RedButton from 'app/components/buttons/RedButton';

import { img } from "app/styles/core";

const internName = 'intern Greg';

const useStyles = makeStyles(theme => ({
    container: {
        zIndex: 12,
        height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage: 'url(/images/page-not-found-bg.jpg)'
    },
    missingContainer: {
        padding: theme.spacing(4),
    },
    missingImage: {
        ...img,
        maxWidth: '320px',
        width: 'auto'
    },
    buttonContainer: {
        marginTop: theme.spacing(4)
    },
    button: {
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2)
    }
}));

export default function PageNotFound(props) {

    const [fire, setFire] = useState('');

    const classes = useStyles();

    useEffect(() => {
        const interSad = new Image();
        interSad.src = '/images/intern-sad-bg.jpg';

        const interHappy = new Image();
        interHappy.src = '/images/intern-happy-bg.jpg';
    })

    const handleFiring = val => {
        setFire(val);
    }

    const content = () => {
        if (fire === 'yes') {
            return (
                <Fragment>
                    <Typography variant='h6' color='textSecondary' gutterBottom>
                        We will notify {internName} of our decision.
                    </Typography>
                    <Typography color='textSecondary' gutterBottom>
                        He needed to be reminded that it takes more than a mediocre liberal arts degree and stellar sock collection to work at Club Apps.
                    </Typography>
                </Fragment>
            )
        } else if (fire === 'no') {
            return (
                <Fragment>
                    <Typography variant='h6' color='textSecondary' gutterBottom>
                        You kept {internName} from being fired!
                    </Typography>
                    <Typography color='textSecondary'>
                        To show his appreciation, he will be sending you a copy of the album he just recorded in his parents basement. We all have high expectations.
                    </Typography>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <Typography variant='h6' color='textSecondary' gutterBottom>
                        Looks like {internName} has failed once again...
                    </Typography>
                    <Typography color='textSecondary' gutterBottom>
                        Yesterday he spilled kombucha all over the break room! We are going to go ahead and tell {internName} to pack up his moustache comb and vespa home.
                    </Typography>
                    <div className={classes.buttonContainer}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={() => setFire('no')}
                            >
                            Save {internName}!
                        </Button>
                        <RedButton
                            onClick={() => setFire('yes')}
                            className={classes.button}
                            variant="contained"
                            >
                            This shall not stand!
                        </RedButton>
                    </div>
                </Fragment>
            )
        }
    }

    const containerImage = () => {
        if (fire === 'yes') {
            return {backgroundImage: 'url(/images/intern-sad-bg.jpg)'}
        } else if (fire === 'no') {
            return {backgroundImage: 'url(/images/intern-happy-bg.jpg)'}
        } else {
            return {backgroundImage: 'url(/images/page-not-found-bg.jpg)'}
        }

    }

    return (
        <Grid
            container
            alignItems="center"
            justify="flex-start"
            className={classes.container}
            style={containerImage()}
            >
            <Grid item className={classes.missingContainer} xs={4}>
                <Typography variant='h4' gutterBottom>
                    404 - Page Not Found
                </Typography>
                {content()}
            </Grid>
        </Grid>
    )
};
